import React from 'react';
import { motion } from 'framer-motion';

const awardsData = [
    {
        id: 1,
        rank: "No. 4",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    },
    {
        id: 2,
        rank: "No. 10",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    },
    {
        id: 3,
        rank: "No. 11",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    },
    {
        id: 4,
        rank: "No. 24",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    },
    {
        id: 5,
        rank: "Top 10",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    },
    {
        id: 6,
        rank: "No. 1",
        description: "on the Great Place To Work® Fortune World's Best Workplaces™, our 4th consecutive year on the list."
    }
];

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.15 }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const GreatPlaceToWorkSection = () => {
    return (
        <section className="w-full pb-[40px] md:pb-[80px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto flex flex-col px-[20px] lg:px-[80px] ">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    className="text-start mb-[32px] md:mb-[60px]"
                >
                    <h2 className="text-[26px] sm:text-[28px] md:text-[31px] font-[600] text-[#01386A] tracking-tight mb-[12px] md:mb-[16px]">
                        A great place to work
                    </h2>
                    <p className="text-[#49577A] text-[15px] md:text-[18px] font-graphik font-medium max-w-[626px] leading-relaxed">
                        Our people power our business and talent strategy, and we want to be the best place for our Reinventors to learn, grow and thrive.
                    </p>
                </motion.div>
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[16px] md:gap-[24px] w-full"
                >
                    {awardsData.map((award) => (
                        <motion.div
                            key={award.id}
                            variants={itemVariants}
                            className="group bg-[#F0F0F0] hover:bg-[#01386A] p-[24px] sm:p-[30px] md:p-[40px] flex flex-col justify-center min-h-[180px] sm:min-h-[224px] transition-colors duration-500 ease-in-out cursor-default"
                        >
                            <h3 className="text-[20px] sm:text-[22px] md:text-[24px] font-sora font-[600] text-[#01386A] group-hover:text-white mb-[16px] sm:mb-[24px] md:mb-[34px] transition-colors duration-500">
                                {award.rank}
                            </h3>
                            <p className="text-[#49577A] text-[14px] sm:text-[15px] md:text-[18px] font-graphik font-medium leading-[1.5] md:leading-[1.6] group-hover:text-white transition-colors duration-500">
                                {award.description}
                            </p>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default GreatPlaceToWorkSection;